import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import classNames from 'classnames';
import {
  Loader,
} from '../../../components';

import { DEFAULT_LANGUAGE, SCREEN_NORMAL } from '../../../config/constants';
import './style.scss';

const KPAnswersRecent = ({ loading, entities, question }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [shouldShow, setShouldShow] = useState(false);

  const questionTitle = question?.getIn([0, 'entity', 'title', '0', 'value']);
  const questionURL = question?.getIn(['0', 'url']);

  const isMobile = useMemo(() => {
    return width < SCREEN_NORMAL;
  });

  const titleClassNames = classNames('ViewKPAnswersRecent__question', {
    'closed': isMobile && !shouldShow,
    'icon-after icon-variant-3': isMobile,
    'icon-chevron-up': shouldShow,
    'icon-chevron-down': !shouldShow,
  });

  useEffect(() => {
    const onBodyClick = () => {
      setShouldShow(false);
    };

    document.body.addEventListener('click', onBodyClick);

    return () => {
      document.body.removeEventListener('click', onBodyClick);
    };
  }, [setShouldShow]);

  const onQuestionClick = (event) => {
    event.stopPropagation();
    if (isMobile) {
      setShouldShow(!shouldShow);
    }
  };

  return (
    <div className="View ViewKPAnswersRecent">
      {!loading && questionTitle && questionURL && (
        <>
          <label
            className={titleClassNames}
            id="ViewKPAnswersRecent_questionTitle"
            onClick={onQuestionClick}>
            {questionTitle}
          </label>
          <ul className={`ViewKPAnswersRecent__answers ${isMobile && !shouldShow ? 'hide' : ''}`}>
            {entities.map((entity) => {
              const title = entity.getIn(['title', '0', 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const answerType = entity.getIn(['field_type_of_answer', 0, 'entity', 'name', 0, 'value'], '').toLowerCase();
              return (
                <li key={`${uuid}:${langcode}`} className="ViewKPAnswersRecent__answer">
                  <CoreLink className="icon-after icon-arrow-right icon-before moving-arrow icon-variant-3" href={entity.getIn(['paths', DEFAULT_LANGUAGE])}>
                    <div className="ViewKPAnswersRecent__answer__icon">
                      <span className={`icon icon-${answerType} icon-variant-3`} />
                    </div>
                    <div className="ViewKPAnswersRecent__answer__text">
                      <span>{title}</span>
                    </div>
                  </CoreLink>
                </li>
              );
            })}
            <li className="ViewKPAnswersRecent__answer">
              <CoreLink className="ViewKPAnswersRecent__answer__allAnswers icon-after icon-arrow-right icon-before moving-arrow icon-variant-1" href={questionURL}>
                {t('kp.all_answers')}
              </CoreLink>
            </li>
          </ul>
        </>
      )}
      <Loader loading={loading} />
    </div>
  );
};

export default KPAnswersRecent;
